// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Mode stylings */

.tradegpt-dark-widget .tradegpt-widget__content {
  background: #1C1C1E;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  overflow: hidden;
}

.tradegpt-dark-widget .tradegpt-widget-username.tradegpt-widget-bot-name {
  color: #E4E5E8;
}

.tradegpt-dark-widget .tradegpt-widget-username {
  color: #5EEECD;
}

.tradegpt-dark-widget .tradegpt-widget__content__footer__input {
  background: #333;
}

.tradegpt-dark-widget textarea.tradegpt-widget-query-input {
  color: #FFFFFF;
}

.tradegpt-dark-widget textarea.tradegpt-widget-query-input::placeholder {
  color: #FFF;
}

.tradegpt-dark-widget .tradegpt-widget__content__footer__hint {
  color: #E4E5E8;
}

.tradegpt-dark-widget .tradegpt-widget__content__get_started__title {
  color: #5EEECD;
}

.tradegpt-dark-widget .tradegpt-widget__content__get_started__item {
  border: 1px solid #5EEECD;
}


.tradegpt-dark-widget .tradegpt-widget__content__get_started__item:hover {
  background-color: #0c0c0c;
}

.tradegpt-dark-widget .chat-bubble {
  background-color: #0a0a0ab8;
}

.tradegpt-dark-widget .tradegpt-widget__content__get_started__item__title {
  color: #5EEECD;
}

.tradegpt-dark-widget .tradegpt-widget-message-action svg {
  fill: #E4E5E8;
}

.tradegpt-dark-widget .tradegpt-widget__sidebar__content__prompt {
  border: 1px solid #5EEECD;
}

.dark .tradegpt-widget-feedback-modal {
  background-color: #363636;
}

.dark .tracking-tighter {
  color: #FFF;
}

.dark .tradegpt-widget-feedback-modal-header svg {
  fill: #fff;
}

.dark .feedback-submit-button {
  border: 1px solid #5EEECD;
  color: #fff !important;
}

.dark .feedback-submit-button:disabled {
  color: rgba(255, 255, 255, 0.26) !important
}

.dark .tradegpt-widget-feedback-modal-body {
  textarea {
    color: white !important;
  }
}

.dark .feedback-submit-button svg {
  fill: #fff !important;
}

.dark .tradegpt-widget-feedback-modal .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border: 1px solid #fff !important;
}

.dark .tradegpt-widget-thankyou-message {
  color: #fff !important;
}

.tradegpt-dark-widget {
  .MuiToolbar-root {
    svg{
      fill: white;
    }
    color: white;
  }
  .tradegpt-widget__sidebar {
    background: #1C1C1E;
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-right: none;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .tradegpt-widget__sidebar__header {

    .tradegpt-widget__sidebar__header__title {
      color: #fff;
    }

    svg path {
      fill: #fff;
    }
  }

  .tradegpt-widget__header {
    .tradegpt-widget__header__title {
      color: rgba(255, 255, 255, 0.8);
    }

    svg path {
      fill: #fff;
    }
  }
  .tradegpt-widget__content-start-message {
    color: rgba(0, 0, 0, 0.60);
    background-image: linear-gradient(
      to right,
      #E4E5E8 0%,
      #E4E5E8 45%,
      rgb(255, 255, 255) 50%,
      #E4E5E8 55%,
      #E4E5E8 100%
    );
  }
  .highcharts-label {
    text {
      fill: black !important;
    }
  }
  .tradegpt-widget-recent-prompts__search {
    border: 1px solid rgba(255, 255, 255, 0.42);

    input {
      color: white;
    }

    svg path {
      fill: #fff;
    }
  }

  .highcharts-background {
    fill: #343540;
  }

  .highcharts-axis-title {
    fill: white !important;
  }

  .tradegpt-widget-recent-prompts__section__title {
    color: rgba(255, 255, 255, 0.8);
  }

  .tradegpt-widget-recent-prompts__section__item {
    svg path {
      fill: #fff;
    }
  }
  .MuiListItemText-primary {
    color: white;
  }

  .MuiListItemText-secondary {
    color: white;
  }

  .MuiDivider-fullWidth {
    border-bottom-color: #494949;
  }

  .MuiDataGrid-menuList {
    .MuiTypography-root {
      color: white !important;
    }
  }

  .highcharts-label text {
    fill: white !important;
  }

  .highcharts-axis-labels text {
    fill: white !important;
  }

  .highcharts-text-outline {
    stroke: black;
    stroke-width: 2px;
  }

  .highcharts-label.highcharts-range-input text {
    fill: white !important;
    text-decoration: underline;
  }

  .highcharts-button-disabled {
    opacity: 0.4;
  }

  .highcharts-background {
    fill: #343540;
  }

  .highcharts-title {
    fill: white !important;
  }

  .highcharts-button-box {
    fill: #7C7C88;
  }
  .tradegpt-widget-recent-prompts__section__item {
    &:hover {
      border-radius: 8px;
      background: black;
    }
  }

  .tgpt-sidebar-active {
    background-color: #4b4b4b;
  }


  .tradegpt-widget-recent-prompts__section__item__title {
    color: #fff;
  }

  .carrot-translator {
    background-color: #fff;
  }
  .highcharts-container .highcharts-stocktools-toolbar {
    background: #333;

    button {
      fill: #666; 
      stroke: #666; 
      &:hover {
        fill: #aaa; 
        stroke: #aaa; 
      }
    }
    .highcharts-button:hover {
      background-color: #555; 
    }
  }
}`, "",{"version":3,"sources":["webpack://./lib/assets/darkmode.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE;MACE,WAAW;IACb;IACA,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;;IAEE;MACE,WAAW;IACb;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,+BAA+B;IACjC;;IAEA;MACE,UAAU;IACZ;EACF;EACA;IACE,0BAA0B;IAC1B;;;;;;;KAOC;EACH;EACA;IACE;MACE,sBAAsB;IACxB;EACF;EACA;IACE,2CAA2C;;IAE3C;MACE,YAAY;IACd;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE;MACE,UAAU;IACZ;EACF;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;EACA;IACE;MACE,kBAAkB;MAClB,iBAAiB;IACnB;EACF;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;;IAEhB;MACE,UAAU;MACV,YAAY;MACZ;QACE,UAAU;QACV,YAAY;MACd;IACF;IACA;MACE,sBAAsB;IACxB;EACF;AACF","sourcesContent":["/* Dark Mode stylings */\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content {\r\n  background: #1C1C1E;\r\n  border: 1px solid rgba(255, 255, 255, 0.8);\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget-username.tradegpt-widget-bot-name {\r\n  color: #E4E5E8;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget-username {\r\n  color: #5EEECD;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content__footer__input {\r\n  background: #333;\r\n}\r\n\r\n.tradegpt-dark-widget textarea.tradegpt-widget-query-input {\r\n  color: #FFFFFF;\r\n}\r\n\r\n.tradegpt-dark-widget textarea.tradegpt-widget-query-input::placeholder {\r\n  color: #FFF;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content__footer__hint {\r\n  color: #E4E5E8;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content__get_started__title {\r\n  color: #5EEECD;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content__get_started__item {\r\n  border: 1px solid #5EEECD;\r\n}\r\n\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content__get_started__item:hover {\r\n  background-color: #0c0c0c;\r\n}\r\n\r\n.tradegpt-dark-widget .chat-bubble {\r\n  background-color: #0a0a0ab8;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content__get_started__item__title {\r\n  color: #5EEECD;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget-message-action svg {\r\n  fill: #E4E5E8;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__sidebar__content__prompt {\r\n  border: 1px solid #5EEECD;\r\n}\r\n\r\n.dark .tradegpt-widget-feedback-modal {\r\n  background-color: #363636;\r\n}\r\n\r\n.dark .tracking-tighter {\r\n  color: #FFF;\r\n}\r\n\r\n.dark .tradegpt-widget-feedback-modal-header svg {\r\n  fill: #fff;\r\n}\r\n\r\n.dark .feedback-submit-button {\r\n  border: 1px solid #5EEECD;\r\n  color: #fff !important;\r\n}\r\n\r\n.dark .feedback-submit-button:disabled {\r\n  color: rgba(255, 255, 255, 0.26) !important\r\n}\r\n\r\n.dark .tradegpt-widget-feedback-modal-body {\r\n  textarea {\r\n    color: white !important;\r\n  }\r\n}\r\n\r\n.dark .feedback-submit-button svg {\r\n  fill: #fff !important;\r\n}\r\n\r\n.dark .tradegpt-widget-feedback-modal .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\r\n  border: 1px solid #fff !important;\r\n}\r\n\r\n.dark .tradegpt-widget-thankyou-message {\r\n  color: #fff !important;\r\n}\r\n\r\n.tradegpt-dark-widget {\r\n  .MuiToolbar-root {\r\n    svg{\r\n      fill: white;\r\n    }\r\n    color: white;\r\n  }\r\n  .tradegpt-widget__sidebar {\r\n    background: #1C1C1E;\r\n    border: 1px solid rgba(255, 255, 255, 0.8);\r\n    border-right: none;\r\n    border-top-left-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n  }\r\n\r\n  .tradegpt-widget__sidebar__header {\r\n\r\n    .tradegpt-widget__sidebar__header__title {\r\n      color: #fff;\r\n    }\r\n\r\n    svg path {\r\n      fill: #fff;\r\n    }\r\n  }\r\n\r\n  .tradegpt-widget__header {\r\n    .tradegpt-widget__header__title {\r\n      color: rgba(255, 255, 255, 0.8);\r\n    }\r\n\r\n    svg path {\r\n      fill: #fff;\r\n    }\r\n  }\r\n  .tradegpt-widget__content-start-message {\r\n    color: rgba(0, 0, 0, 0.60);\r\n    background-image: linear-gradient(\r\n      to right,\r\n      #E4E5E8 0%,\r\n      #E4E5E8 45%,\r\n      rgb(255, 255, 255) 50%,\r\n      #E4E5E8 55%,\r\n      #E4E5E8 100%\r\n    );\r\n  }\r\n  .highcharts-label {\r\n    text {\r\n      fill: black !important;\r\n    }\r\n  }\r\n  .tradegpt-widget-recent-prompts__search {\r\n    border: 1px solid rgba(255, 255, 255, 0.42);\r\n\r\n    input {\r\n      color: white;\r\n    }\r\n\r\n    svg path {\r\n      fill: #fff;\r\n    }\r\n  }\r\n\r\n  .highcharts-background {\r\n    fill: #343540;\r\n  }\r\n\r\n  .highcharts-axis-title {\r\n    fill: white !important;\r\n  }\r\n\r\n  .tradegpt-widget-recent-prompts__section__title {\r\n    color: rgba(255, 255, 255, 0.8);\r\n  }\r\n\r\n  .tradegpt-widget-recent-prompts__section__item {\r\n    svg path {\r\n      fill: #fff;\r\n    }\r\n  }\r\n  .MuiListItemText-primary {\r\n    color: white;\r\n  }\r\n\r\n  .MuiListItemText-secondary {\r\n    color: white;\r\n  }\r\n\r\n  .MuiDivider-fullWidth {\r\n    border-bottom-color: #494949;\r\n  }\r\n\r\n  .MuiDataGrid-menuList {\r\n    .MuiTypography-root {\r\n      color: white !important;\r\n    }\r\n  }\r\n\r\n  .highcharts-label text {\r\n    fill: white !important;\r\n  }\r\n\r\n  .highcharts-axis-labels text {\r\n    fill: white !important;\r\n  }\r\n\r\n  .highcharts-text-outline {\r\n    stroke: black;\r\n    stroke-width: 2px;\r\n  }\r\n\r\n  .highcharts-label.highcharts-range-input text {\r\n    fill: white !important;\r\n    text-decoration: underline;\r\n  }\r\n\r\n  .highcharts-button-disabled {\r\n    opacity: 0.4;\r\n  }\r\n\r\n  .highcharts-background {\r\n    fill: #343540;\r\n  }\r\n\r\n  .highcharts-title {\r\n    fill: white !important;\r\n  }\r\n\r\n  .highcharts-button-box {\r\n    fill: #7C7C88;\r\n  }\r\n  .tradegpt-widget-recent-prompts__section__item {\r\n    &:hover {\r\n      border-radius: 8px;\r\n      background: black;\r\n    }\r\n  }\r\n\r\n  .tgpt-sidebar-active {\r\n    background-color: #4b4b4b;\r\n  }\r\n\r\n\r\n  .tradegpt-widget-recent-prompts__section__item__title {\r\n    color: #fff;\r\n  }\r\n\r\n  .carrot-translator {\r\n    background-color: #fff;\r\n  }\r\n  .highcharts-container .highcharts-stocktools-toolbar {\r\n    background: #333;\r\n\r\n    button {\r\n      fill: #666; \r\n      stroke: #666; \r\n      &:hover {\r\n        fill: #aaa; \r\n        stroke: #aaa; \r\n      }\r\n    }\r\n    .highcharts-button:hover {\r\n      background-color: #555; \r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
